
jQuery(document).ready(function($){

	var position = $(window).scrollTop();
	var moffset = $("#masthead-and-nav-wrapper").offset().top;
	var mheight = $("#masthead-and-nav-wrapper").height();
	var mastheadheight = $("#masthead-and-nav-wrapper").outerHeight();
	var wrapperheight = moffset + mheight;
	var stickytop = 0;


	 
	// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function addstickyclasses(){
		$("#masthead-and-nav-wrapper").addClass("sticky-nav");
		if($('body').hasClass('admin-bar')){
			stickytop = 32;
		}
		$("#masthead-and-nav-wrapper").css({ top: stickytop });
		$('.masthead-space-holder').css({"height":mastheadheight + "px"} );

	}

	function removestickyclasses(){
		$("#masthead-and-nav-wrapper").removeClass("sticky-nav");
	}

	// If user lands on the page and not at the masthead, apply stickyclasses
	if (position > wrapperheight) {
  		addstickyclasses();
  	}

	// When the user scrolls the page, execute stickyFunction 
	window.onscroll = function() {stickyFunction()};	  	

	function stickyFunction() {

		var scroll = $(window).scrollTop();
		var stickyposition = '0';

		/* See if there is an emergency banner in place */
		if($("#emergencywrapper").length) {
			var topofBanner = $("#emergencywrapper").offset().top; 
			var heightofBanner = $("#emergencywrapper").outerHeight(); 
			if($('#emergencywrapper').css('display') != 'none'){
				stickyposition = topofBanner + heightofBanner;
			}
			
		}

		//see if user is logged into wordpress and there is a nav bar
		if($('body').hasClass('admin-bar')){
			stickyposition = stickyposition + 32;
		}
		
		console.log(stickyposition);
		// compare the page position offset to the masthead height and add or remove classes
		if(scroll < position) {
			// User is scrolling up

			//If the user is above the height of the masthead and nav, remove sticky classes
			if (window.pageYOffset <= stickyposition) {
		 		removestickyclasses();
		 		$("#sticky-masthead").slideDown();
		 	}
		 	if ($(window).width() > 1024) {
	  	    	$("#sticky-masthead").slideDown();
	  	    }	
		  
		  	
		} else {
			// User is scrolling down more than a few pixels
			if((scroll) > position){
	  	    	//If the user is scrolling down add sticky classes
	  	    	if ((window.pageYOffset > stickyposition)) {
	  	      		addstickyclasses();
	  	      		$("#sticky-masthead").slideUp();
	  	      	}
	  	      }
		}

		position = scroll;

	}

});


    

